import ReactDOM from "react-dom/client";
import SRP from '@/frontend/algolia/search-results';
import CLP from '@/frontend/algolia/collection-list';
import InstantSearch from "@/frontend/algolia/instant-search";
import { InstantSearchConfig, CollectionPageConfig, ConfigContext } from "../algolia/config";
import { ListenerEvent, ListenerArgs, ListenerFunction, Pubsub } from "../algolia/_helpers";

export { getSiteCode } from '../scripts/_global';

// import reportWebVitals from "./reportWebVitals";

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// --------------------------

const aSR = document.getElementById("algolia-search-results");

if (aSR) ReactDOM.createRoot(aSR).render(<SRP />);

// ------------

window.AlgoliaCollectionPage = {
  init: (config: CollectionPageConfig = {}) => {

    const configContext = {
      ...config,
    }

    const CP = document.getElementById("algolia-collection-list");
    const CollectionHandle = CP?.dataset?.collection;

    ReactDOM.createRoot(CP!).render(
      <ConfigContext.Provider value={configContext}>
        <CLP collectionHandle={CollectionHandle!} />
      </ConfigContext.Provider>
    );
  },
}

// ------------

window.AlgoliaInstantSearch = {
  init: (config: InstantSearchConfig) => {
    const pubsub = new Pubsub();

    const configContext = {
      ...config,
      publish: (event: ListenerEvent, ...args: ListenerArgs) => pubsub.publish(event, ...args),
    }

    ReactDOM.createRoot(document.getElementById("instant-search")!).render(
      <ConfigContext.Provider value={configContext}>
        <InstantSearch isPortal={false} triggerClassName={config.triggerClassName} />
      </ConfigContext.Provider>
    );

    return {
      on: (event: ListenerEvent, listener: ListenerFunction) => pubsub.on(event, listener),
    }
  },
}
